export default "__VITE_ASSET__CVkjMTXu__"